import { PermissionRole } from 'pages/AddUser/AddUserForm/types';
import { ROLES } from 'variables';

export type RoleOptions = {
  value: PermissionRole;
  label: string;
}[];
export const getRolePermissionV2Options = (
  t: (key: string) => string,
  isInsightsUser: boolean | undefined,
  roles?: PermissionRole[],
): RoleOptions => {
  const options: RoleOptions = [
    {
      value: 'RESTRICTED_USER',
      label: t(ROLES.RESTRICTED_USER),
    },
    {
      value: 'STANDARD',
      label: t(ROLES.STANDARD),
    },
  ];
  if (isInsightsUser) {
    options.push({
      value: 'CLIENT_SERVICES',
      label: t(ROLES.SUPER_ADMIN),
    });
  } else {
    options.push(
      {
        value: 'ADVANCED_USER',
        label: t(ROLES.ADVANCED_USER),
      },
      {
        value: 'GROUP_MANAGER',
        label: t(ROLES.GROUP_MANAGER),
      },
    );
  }

  return roles?.length
    ? options.filter((option) => roles.includes(option.value))
    : options;
};
